import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import {
  Header,
  HeaderContent,
  HeaderToggler,
  Collapse,
  Nav,
  NavItem,
  Icon,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  LinkList,
} from "design-react-kit";
import { LESSON_ACTIVITY_TYPES, REVISOR_CONTEXTS, ROUTES } from "../../const";
import { getRevisionContexts } from "store/actions";

export class NHRevisore extends Component {
  state = {
    collapsed: true,
  };

  manageEvtByLink = (link) => {
    this.setState({ collapsed: true });
  };

  renderRevisionLinks = (contextRoutes, isEnglish = false, otherItems = null) => (
    <>
      {/* Revisioni Correnti */}
      <NavItem tag="li" onClick={() => this.manageEvtByLink()}>
        <NavLink className="list-item" to={contextRoutes.current} tag="a">
          Revisioni Correnti
        </NavLink>
      </NavItem>

      {/* Storico Revisioni */}
      <NavItem tag="li" onClick={() => this.manageEvtByLink()}>
        <NavLink className="list-item" to={contextRoutes.history} tag="a">
          Storico Revisioni
        </NavLink>
      </NavItem>

      {/* Revisioni non idonee */}
      {!isEnglish && (
        <NavItem tag="li" onClick={() => this.manageEvtByLink()}>
          <NavLink className="list-item" to={contextRoutes.pending} tag="a">
            Revisioni non idonee
          </NavLink>
        </NavItem>
      )}

      {otherItems}
    </>
  );

  getLessonActivityRoutes = (context, activityType) => {
    const lessonActivityRoute = {
      current: `${ROUTES.CURRENT_REVISION_LESSON_ACTIVITY}/${context}/${activityType}`,
      history: `${ROUTES.HISTORY_REVISION_LESSON_ACTIVITY}/${context}/${activityType}/revisioned`,
      pending: `${ROUTES.PENDING_REVISION_LESSON_ACTIVITY}/${context}/${activityType}/revisionPending`,
    };
    return lessonActivityRoute;
  };

  getLessonActivitySecurityRoutes = () => {
    const securityRoute = {
      current: `${ROUTES.CURRENT_REVISION_SECURITY}`,
      history: `${ROUTES.HISTORY_REVISION_SECURITY}/download`,
      pending: `${ROUTES.PENDING_REVISION_SECURITY}/securityPending`,
    };
    return securityRoute;
  };

  renderLessonActivity = (context) => {
    const abilitantiRoutes = this.getLessonActivityRoutes(context, LESSON_ACTIVITY_TYPES.ABILITAZIONI);
    const tfaRoutes = this.getLessonActivityRoutes(context, LESSON_ACTIVITY_TYPES.TFA_CLASSICO);
    const securityRoutes = this.getLessonActivitySecurityRoutes(context, LESSON_ACTIVITY_TYPES.TFA_CLASSICO);
    const tfaIndireRoutes = this.getLessonActivityRoutes(context, LESSON_ACTIVITY_TYPES.TFA_INDIRE);

    return (
      <>
        <NavItem tag="li">
          <b className="px-4 text-white">PERCORSI ABILITANTI</b>
        </NavItem>

        {this.renderRevisionLinks(abilitantiRoutes)}

        <hr />

        <NavItem tag="li">
          <b className="px-4 text-white">TFA INDIRE</b>
        </NavItem>

        {this.renderRevisionLinks(tfaIndireRoutes)}

        <hr />

        <NavItem tag="li">
          <b className="px-4 mb-1 text-white">TFA CLASSICO</b>          
        </NavItem>
        <hr/>
        <NavItem tag="li">
          <b className="px-4 text-white">Attestati sulla sicurezza</b>
        </NavItem>

        {this.renderRevisionLinks(securityRoutes)}

        <hr className="my-2" />

        <NavItem tag="li">
          <b className="px-4 text-white">Documentazione finale</b>
        </NavItem>

        {this.renderRevisionLinks(tfaRoutes)}
      </>
    );
  };

  getLessonActivityCompanyRoutes = (context, activityType) => {
    const lessonActivityCompanyRoute = {
      current: `${ROUTES.CURRENT_REVISION_LESSON_ACTIVITY_COMPANY}/${context}/${activityType}`,
      history: `${ROUTES.HISTORY_REVISION_LESSON_ACTIVITY_COMPANY}/${context}/${activityType}/approved`,
      pending: `${ROUTES.PENDING_REVISION_LESSON_ACTIVITY_COMPANY}/${context}/${activityType}/approvePending`,
    };
    return lessonActivityCompanyRoute;
  };

  renderLessonActivityCompany = (context) => {
    const abilitantiRoutes = this.getLessonActivityCompanyRoutes(context, LESSON_ACTIVITY_TYPES.ABILITAZIONI);
    const tfaRoutes = this.getLessonActivityCompanyRoutes(context, LESSON_ACTIVITY_TYPES.TFA_CLASSICO);

    return (
      <>
        <NavItem tag="li">
          <b className="px-4 text-white">PERCORSI ABILITANTI</b>
        </NavItem>

        {this.renderRevisionLinks(abilitantiRoutes)}

        <hr />
        <NavItem tag="li">
          <b className="px-4 text-white">TFA XI CICLO</b>
        </NavItem>

        {this.renderRevisionLinks(
          tfaRoutes,
          false,
          <NavItem tag="li" onClick={() => this.manageEvtByLink()}>
            <NavLink
              className="list-item"
              to={`${ROUTES.SECURITY_CERTIFICATES_LESSON_ACTIVITY_COMPANY}/${context}/${LESSON_ACTIVITY_TYPES.TFA_CLASSICO}`}
              tag="a"
            >
              Attestati sulla sicurezza
            </NavLink>
          </NavItem>,
        )}
      </>
    );
  };

  renderRevisionContexts = (revisionContexts) => {
    return revisionContexts.map((context, index) => {
      let isLessonActivity = false;
      let isLessonActivityCompany = false;
      let isEnglish = false;
      let isTFAIndire = false;
      let contextLabel = context;

      switch (context) {
        case REVISOR_CONTEXTS.TIROCINIODIRETTO:
          isLessonActivity = true;
          contextLabel = "Tirocinio Diretto";
          break;
        case REVISOR_CONTEXTS.TIROCINIODIRETTOCOMPANY:
          isLessonActivityCompany = true;
          contextLabel = "Tirocinio Diretto (Università)";
          break;
        case REVISOR_CONTEXTS.ENGLISH:
          isEnglish = true;
          contextLabel = REVISOR_CONTEXTS.ENGLISH;
          break;
        case REVISOR_CONTEXTS.TFAINDIRE:
          isTFAIndire = true;
          contextLabel = REVISOR_CONTEXTS.TFAINDIRE;
          break;
        default:
          break;
      }

      const contextRoutes = {
        current: `${ROUTES.DASHBOARD}/${context}`,
        history: `${ROUTES.HISTORY_REVISION}/${context}`,
        pending: `${ROUTES.PENDING_REVISION}/${context}`,
      };

      return (
        <NavItem key={index} tag="li">
          <UncontrolledDropdown nav tag="div">
            <UncontrolledDropdown>
              <DropdownToggle aria-haspopup caret color="secondary" nav>
                {contextLabel.toUpperCase()}
              </DropdownToggle>

              <DropdownMenu flip ag="div" className="dropdown-menu-show-fix mnemo-dark">
                <LinkList tag="div">
                  <>
                    {isLessonActivityCompany && this.renderLessonActivityCompany(context)}
                    {isLessonActivity && this.renderLessonActivity(context)}
                    {isTFAIndire && this.renderRevisionLinks(this.getLessonActivityRoutes(context, LESSON_ACTIVITY_TYPES.TFA_INDIRE))}
                    {isEnglish && this.renderRevisionLinks(contextRoutes, isEnglish)}
                    {!isLessonActivity && !isTFAIndire && !isLessonActivityCompany && !isEnglish && this.renderRevisionLinks(contextRoutes, false)}
                  </>
                </LinkList>
              </DropdownMenu>
            </UncontrolledDropdown>
          </UncontrolledDropdown>
        </NavItem>
      );
    });
  };

  //--- ---

  render() {
    const isOpen = !this.state.collapsed;
    const revisionContexts = getRevisionContexts();

    return (
      <>
        <Header small theme="" type="navbar">
          <HeaderContent expand="lg" megamenu>
            <HeaderToggler
              aria-controls="nav1"
              aria-expanded="false"
              aria-label="Toggle navigation"
              onClick={() => this.setState({ collapsed: isOpen })}
            >
              <Icon icon="it-burger" />
            </HeaderToggler>
            <Collapse isOpen={isOpen} navbar header onOverlayClick={() => this.setState({ collapsed: true })}>
              <div className="menu-wrapper mnemo-dark">
                <Nav navbar tag="ul" vertical={false}>
                  <NavItem key={`menu-item-close`} tag="li" onClick={() => this.setState({ collapsed: isOpen })}>
                    <div className="mnemo-close-li">
                      CHIUDI <Icon icon="it-close-circle" padding={false} />
                    </div>
                  </NavItem>

                  {this.renderRevisionContexts(revisionContexts)}

                  <NavItem tag="li" onClick={this.props.logout}>
                    <NavLink className="nav-link" to="/" ag="a">
                      Esci
                    </NavLink>
                  </NavItem>
                </Nav>
              </div>
            </Collapse>
          </HeaderContent>
        </Header>
      </>
    );
  }
}
